<mat-card class="not-found-card">
    <mat-card-content>
        <img class="not-found-image" src="../../assets/404-error.jpg" alt="404" />
    </mat-card-content>
</mat-card>